<selfai-platform-data-list-view
  [layoutTypes]="['table']"
  [columns]="columns"
  [showEntityIcon]="true"
  [groupActions]="groupActions$ | async"
  [emptyMessage]="'shell.board.filter.ui.search-all.nodata' | translate"
>
</selfai-platform-data-list-view>
